var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTutorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99735 1.86667C2.5187 1.86667 2.13068 2.26503 2.13068 2.75644V11.2436C2.13068 11.735 2.5187 12.1333 2.99735 12.1333H17.6277C18.1063 12.1333 18.4943 11.735 18.4943 11.2436V2.75644C18.4943 2.26503 18.1063 1.86667 17.6277 1.86667H2.99735ZM0.3125 2.75644C0.3125 1.2341 1.51455 0 2.99735 0H17.6277C19.1105 0 20.3125 1.2341 20.3125 2.75644V11.2436C20.3125 12.7659 19.1105 14 17.6277 14H2.99735C1.51455 14 0.3125 12.7659 0.3125 11.2436V2.75644Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.9187C0 16.401 0.419733 15.9812 0.9375 15.9812H12.4563C12.974 15.9812 13.3938 16.401 13.3938 16.9187C13.3938 17.4365 12.974 17.8562 12.4563 17.8562H0.9375C0.419733 17.8562 0 17.4365 0 16.9187Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9937 16.9187C15.9937 16.401 16.4134 15.9812 16.9312 15.9812H18.7125C19.2302 15.9812 19.65 16.401 19.65 16.9187C19.65 17.4365 19.2302 17.8562 18.7125 17.8562H16.9312C16.4134 17.8562 15.9937 17.4365 15.9937 16.9187Z",
    fill: "#3D0E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2875 16.025C13.7939 16.025 13.3938 16.4251 13.3938 16.9187C13.3938 17.4123 13.7939 17.8125 14.2875 17.8125C14.7812 17.8125 15.1813 17.4123 15.1813 16.9187C15.1813 16.4251 14.7812 16.025 14.2875 16.025ZM11.5188 16.9187C11.5188 15.3896 12.7584 14.15 14.2875 14.15C15.8167 14.15 17.0563 15.3896 17.0563 16.9187C17.0563 18.4479 15.8167 19.6875 14.2875 19.6875C12.7584 19.6875 11.5188 18.4479 11.5188 16.9187Z",
    fill: "#718AF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61365 4.75665C8.80069 4.64497 9.03365 4.63672 9.22845 4.73487L12.6384 6.45309C12.8476 6.55854 12.9792 6.76961 12.9792 7.00001C12.9792 7.2304 12.8476 7.44147 12.6384 7.54692L9.22845 9.26514C9.03365 9.36329 8.80069 9.35504 8.61365 9.24336C8.42661 9.13168 8.3125 8.93269 8.3125 8.71822V5.28179C8.3125 5.06732 8.42661 4.86833 8.61365 4.75665Z",
    fill: "#718AF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTutorial);
export default __webpack_public_path__ + "static/media/ic-tutorial.5428d95a896fc576150937ea80482c4c.svg";
export { ForwardRef as ReactComponent };